/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { ClientCredentialsOAuthFlow } from '../../../core/models/common/ClientCredentialsOAuthFlow';
import { IVisitor } from '../../../core/visitors/IVisitor';
import { IOas30Visitor } from '../visitors/IOas30Visitor';

/**
 * Models an OpenAPI 3.0.x client credentials OAuth flow.
 * 
 * @author eric.wittmann@gmail.com
 * @class
 * @extends ClientCredentialsOAuthFlow
 */
export class Oas30ClientCredentialsOAuthFlow extends ClientCredentialsOAuthFlow {
    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let viz : IOas30Visitor = <IOas30Visitor><any>visitor;
        viz.visitClientCredentialsOAuthFlow(this);
    }

    constructor() {
        super();
    }
}
Oas30ClientCredentialsOAuthFlow["__class"] = "io.apicurio.datamodels.openapi.v3.models.Oas30ClientCredentialsOAuthFlow";
Oas30ClientCredentialsOAuthFlow["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




